
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/global",
      function () {
        return require("private-next-pages/global/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/global"])
      });
    }
  